import { NavLink } from 'react-router';

export function SettingsNav({ projectKey }: { projectKey: string }) {
  const base = `/projects/${projectKey}/settings`;
  return (
    <nav className="tabs" aria-label="Project settings">
      <NavLink end to={base} className="tab">
        General
      </NavLink>
      <NavLink to={`${base}/members`} className="tab">
        Members
      </NavLink>
      <NavLink to={`${base}/repository-builders`} className="tab">
        Repository and builders
      </NavLink>
      <NavLink to={`${base}/environments`} className="tab">
        Environments
      </NavLink>
      <NavLink to={`/projects/${projectKey}/context/overview`} className="tab">
        Context
      </NavLink>
    </nav>
  );
}
